import { useDaily } from '@daily-co/daily-react';
import { createContext, useContext, useEffect, useMemo, useState } from 'react';
import { backendBaseUrl } from '../config/backend';
import useWS from '../hooks/useWS';
import { roomIdFromRoomUrl } from '../utils';

const WSMessageContext = createContext();

export function WSMessageProvider({ children }) {
  const daily = useDaily();

  // Extrai roomId do objeto daily - só conecta quando Daily estiver pronto
  const [roomId, setRoomId] = useState(null);

  useEffect(() => {
    if (!daily) {
      setRoomId(null);
      return;
    }

    const extractRoomId = async () => {
      try {
        const roomInfo = await daily.room();

        // Pega apenas a URL (mais confiável que o name)
        const roomUrl = roomInfo?.url || roomInfo?.roomUrlPendingJoin;
        const extractedId = roomIdFromRoomUrl(roomUrl);

        if (extractedId) {
          setRoomId(extractedId);
          return;
        }

        setRoomId(null);

      } catch (error) {
        setRoomId(null);
      }
    };

    extractRoomId();
  }, [daily]);

  // Só conecta WebSocket se tiver roomId válido
  const { messages, isConnected, error, sendMessage, joinRoom } = useWS({
    url: backendBaseUrl,
    roomId: roomId || 'aguardando-daily' // Usa um ID temporário que não vai conectar
  });

  const value = useMemo(() => ({
    // Campos do WebSocket
    messages,
    isConnected,
    error: error || null,
    sendMessage,
    joinRoom,
    roomId, // Também expor o roomId para uso manual
  }), [messages, isConnected, error, sendMessage, joinRoom, roomId]);

  return (
    <WSMessageContext.Provider value={value}>
      {children}
    </WSMessageContext.Provider>
  );
}

export function useWSMessage() {
  const context = useContext(WSMessageContext);
  if (!context) {
    throw new Error('useWSMessage deve ser usado dentro de um WSMessageProvider');
  }
  return context;
}
